<h2 mat-dialog-title>Aspekttext för aspekt {{ aspectName }}</h2>
<form #form="ngForm" [formGroup]="aspectTextForm" (ngSubmit)="save(true)" novalidate class="flex-col gap-1em" autocomplete="off">
  <mat-dialog-content>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Namn</mat-label>
        <input matInput formControlName="name" required />
        @if (getFormControl('name').hasError('required')) {
          <mat-error>Namn är obligatoriskt</mat-error>
        }
        @if (getFormControl('name').hasError('maxlength')) {
          <mat-error>Namn får inte innehålla mer än 100 tecken</mat-error>
        }
      </mat-form-field>
      <div class="flex-1">
        <mat-checkbox formControlName="enabled">Aktiv</mat-checkbox>
      </div>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em" formArrayName="businessCategories">
      <fieldset style="min-width: 300px;">
        <legend>Verksamhetskategorier</legend>
        @for (businessCategoryFormGroup of businessCategoriesArray.controls; track businessCategoryFormGroup; let idx = $index) {
          <div [formGroupName]="idx">
            <mat-checkbox formControlName="selected">{{ businessCategoryFormGroup.get("businessCategoryName").value }}</mat-checkbox>
            <input type="hidden" formControlName="businessCategoryId" />
          </div>
        }
      </fieldset>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em" formArrayName="businessCategories">
      <span style="height: 10px"></span>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Sortering</mat-label>
        <input matInput formControlName="sortOrder" />
      </mat-form-field>
      <mat-form-field class="flex-1">
        <mat-label>Version</mat-label>
        <input matInput formControlName="versionNo" [readonly]="true" />
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Omfattning</mat-label>
        <textarea rows="4" matInput formControlName="scopeDescription" ></textarea>
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Guidande frågor</mat-label>
        <textarea rows="4" matInput formControlName="guidelinesDescription"></textarea>
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Åtgärder krävs</mat-label>
        <textarea rows="4" matInput formControlName="actionsRequiredDescription"></textarea>
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Godtagbart</mat-label>
        <textarea rows="4" matInput formControlName="acceptableDescription"></textarea>
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Bra</mat-label>
        <textarea rows="4" matInput formControlName="goodDescription"></textarea>
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Mycket bra</mat-label>
        <textarea rows="4" matInput formControlName="veryGoodDescription"></textarea>
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Utmärkt</mat-label>
        <textarea rows="4" matInput formControlName="excellentDescription"></textarea>
      </mat-form-field>
    </div>
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Enastående</mat-label>
        <textarea rows="4" matInput formControlName="outstandingDescription"></textarea>
      </mat-form-field>
    </div>
    @if (!isNew) {
      <div class="flex-row flex-col-ltmd gap-col-1em">
        <mat-form-field class="flex-1" [hidden]="isNew">
          <mat-label>Skapad av</mat-label>
          <input matInput [readonly]="true" value="{{ createdByName$ | async }}" />
        </mat-form-field>
        <mat-form-field class="flex-1">
          <mat-label>Skapad</mat-label>
          <input matInput formControlName="createdDate" [readonly]="true" />
        </mat-form-field>
      </div>
    }
    @if (!isNew && changedByName$) {
      <div class="flex-row flex-col-ltmd gap-col-1em">
        <mat-form-field class="flex-1">
          <mat-label>Uppdaterad av</mat-label>
          <input matInput [readonly]="true" value="{{ changedByName$ | async }}" />
        </mat-form-field>
        <mat-form-field class="flex-1">
          <mat-label>Uppdaterad</mat-label>
          <input matInput formControlName="updatedDate" [readonly]="true" />
        </mat-form-field>
      </div>
    }
    <div class="flex-row flex-col-ltmd gap-col-1em">
      <mat-form-field class="flex-1">
        <mat-label>Id</mat-label>
        <input matInput formControlName="aspectTextId" [readonly]="true" />
      </mat-form-field>
      <mat-form-field class="flex-1">
        <mat-label>Aspect Id</mat-label>
        <input matInput formControlName="aspectId" [readonly]="true" />
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    @if (hasPermissionToChange) {
      <button mat-raised-button type="submit" color="primary" title="{{'commands.SaveAndClose' | translate }}">{{ 'commands.SaveAndClose' | translate }}</button>
    }
    @if (hasPermissionToChange) {
      <button mat-raised-button type="button" (click)="save(false)" color="accent" title="{{'commands.Save' | translate }}">{{ 'commands.Save' | translate }}</button>
    }
    <button mat-raised-button type="button" (click)="cancel()">{{ 'commands.Close' | translate }}</button>
  </mat-dialog-actions>
</form>
